export default {
  title: 'Mon devis',
  titles: {
    rights: 'Vos droits',
    demand: 'Votre demande',
  },
  subtitles: {
    theoretical: 'Droits théoriques',
    reals: 'Droits réels',
  },
  tab: {
    theoreticalVolumeRightCCR: 'Droit cubage théorique (CCR)',
    theoreticalVolumeRightPFMD: 'Droit cubage théorique (calcul PFMD)',
    theoreticalRepaymentLimitCCR: 'Plafond remboursement théorique (CCR)',
    realVolumeTransported: 'Volume réellement transporté',
    realReimbursementLimit: 'Plafond remboursement réel',
    projectFileNumber: 'Numéro de dossier',
    fileNumber: 'Numéro de dossier PFMD',
    plafondVolDiff: 'ATTENTION : Le droit de cubage théorique indiqué par votre CCR est différent du droit de cubage théorique vérifié par la PFMD. Cela peut avoir un impact sur le calcul de votre plafond de remboursement réel.',
    realRefund: 'Le plafond de remboursement réel est estimé sur la base du volume réellement transporté, des conditions d’accès à vos logements et du plafond de cubage thérorique indiqué par votre CCR.<br/>Le plafond de remboursement réel n\'est qu\'une valeur estimative. Le calcul des indemnités de changement de résidence reste du ressort @:{\'base.minarm_organism_du\'}.',
  },
  address: {
    name: 'Adresse',
    loading: 'Chargement',
    shipping: 'Livraison',
    access: 'Accès',
    floor: 'Étage',
    lift: 'Ascenseur',
    carrying: 'Portage',
    the: 'Le {date}',
    betweenDate: 'Entre le {date1}<br>Et le {date2}',
    clientDate: 'Votre demande',
    finalDate: 'Date envisagée',
  },
  customerAddresses: {
    title: 'Mes adresses',
    pendingAnalysis: 'Modification en cours d’analyse',
    notice: 'Vos modifications ont bien été enregistrées. Notre équipe va les vérifier et effectuer les ajustements nécessaires sur votre dossier. Vous pouvez poursuivre votre parcours normalement.',
    completeTitle: 'Vos informations sont bien enregistrées',
    incompleteTitle: 'Il manque encore quelques informations pour finaliser cette étape',
    placeholder: 'À compléter',
    editAction: 'Modifier',
    completeAction: 'Compléter',
    housing: 'Logement',
    furnitureLift: 'Monte-meuble',
    furnitureLiftRequired: 'Obligatoire',
    furnitureLiftAvailable: 'Utilisable',
    furnitureLiftRecommended: 'Conseillé',
    lift: {
      with: 'Avec ascenseur',
      without: 'Sans ascenseur',
    },
    cardTitle: {
      chargement: 'Adresse de chargement',
      livraison: 'Adresse de livraison',
    },
    empty: {
      chargement: 'Aucune adresse de chargement',
      livraison: 'Aucune adresse de livraison',
    },
    editFlow: {
      backToList: 'Retour à mes adresses',
      stepCounter: 'Étape {current} sur {total}',
      submit: 'Enregistrer',
      validate: 'Valider mes informations',
      saving: 'Enregistrement...',
      unknown: 'Je ne sais pas',
      addressTitle: {
        chargement: 'Quelle est l’adresse de chargement ?',
        livraison: 'Quelle est l’adresse de livraison ?',
      },
      addressIncomplete: 'Sélectionnez une adresse complète (rue, code postal, ville).',
      addressManualLabel: 'Saisissez votre adresse',
      addressNotFound: 'Je ne trouve pas mon adresse',
      addressSearchAgain: 'Rechercher mon adresse',
      steps: {
        address: 'Adresse',
        housing: 'Logement',
        floor: 'Étage',
        access: 'Accès',
      },
      fields: {
        street: 'Adresse',
        postal: 'Code postal',
        city: 'Ville',
        country: 'Pays',
        housingType: 'Type de logement',
        housingTypeQuestion: 'Quel est le type de logement ?',
        surface: 'Surface en m²',
        cave: 'Cave',
        caveQuestion: 'Y a-t-il une cave ?',
        caveComment: 'Précisions sur la cave',
        floor: 'Étage',
        floorQuestion: {
          chargement: 'À quel(s) étage(s) le chargement est-il prévu ?',
          livraison: 'À quel(s) étage(s) la livraison est-elle prévue ?',
        },
        basement: 'Sous-sol',
        lift: 'Y a-t-il un ascenseur ?',
        liftQuestion: 'Y a-t-il un ascenseur à l’adresse de {type} ?',
        liftComment: 'Taille de l’ascenseur',
        allInLift: 'Est-ce que tous les meubles rentrent dans l’ascenseur ?',
        allInLiftComment: 'Précisions sur le passage dans l’ascenseur',
        stairs: 'Est-ce que tous les meubles passent par l’escalier ?',
        stairsComment: 'Précisions sur l’escalier',
        furnitureLift: 'Peut-on utiliser un monte-meuble ?',
        furnitureLiftComment: 'Type de monte-meuble',
        furnitureLiftRequired: 'Le monte-meuble est-il obligatoire ?',
        parkingType: 'Stationnement',
        portage: 'Distance de portage',
      },
    },
    status: {
      complet: 'Complet',
      a_completer: 'À compléter',
    },
  },
  chosenOptions: {
    subtitle: 'Options choisies',
  },
  services: {
    title: 'Prestations complémentaires incluses',
    subtitle: 'Services inclus',
  },
  options: 'Options proposées',
};
